"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _fetchUtils = _interopRequireDefault(require("../../fetchUtils"));

var _datalist = _interopRequireDefault(require("../datalist"));

var _formatDate = require("../../lib/format-date");

var _loader = _interopRequireDefault(require("../loader"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var DashboardFarmList = /*#__PURE__*/function (_React$Component) {
  _inherits(DashboardFarmList, _React$Component);

  function DashboardFarmList(props) {
    var _this;

    _classCallCheck(this, DashboardFarmList);

    _this = _possibleConstructorReturn(this, (DashboardFarmList.__proto__ || Object.getPrototypeOf(DashboardFarmList)).call(this, props));
    _this.state = {
      list: [],
      isLoading: false
    };
    _this.loadFarms = _this.loadFarms.bind(_assertThisInitialized(_this));
    _this.columnCanton = _this.columnCanton.bind(_assertThisInitialized(_this));
    _this.columnDateCreate = _this.columnDateCreate.bind(_assertThisInitialized(_this));
    _this.columnFarmDetailLink = _this.columnFarmDetailLink.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(DashboardFarmList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this._isMounted = true;
      this.loadFarms(); // do the polling for unchecked farms

      setInterval(function () {
        _this2.loadFarms();
      }, 1000 * 60 * 5);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var t = this.props.t;
      var _this$state = this.state,
          list = _this$state.list,
          isLoading = _this$state.isLoading;
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, !isLoading && /*#__PURE__*/_react.default.createElement(_datalist.default, {
        initialData: list,
        enableSort: true,
        isLoading: isLoading,
        staticTexts: {
          noData: t('no data'),
          loading: t('loading data')
        },
        columns: [{
          title: '',
          render: this.columnFarmDetailLink
        }, {
          title: t('register date'),
          render: this.columnDateCreate,
          prop: 'date_create'
        }, {
          title: t('last name'),
          prop: 'last_name'
        }, {
          title: t('canton'),
          render: this.columnCanton,
          prop: 'canton_name',
          defaultContent: '-'
        }],
        initialPageLength: 20,
        keys: ['id'],
        showSearch: false
      }), isLoading && /*#__PURE__*/_react.default.createElement(_loader.default, {
        size: 'medium'
      }));
    }
    /**
     *
     */

  }, {
    key: "loadFarms",
    value: function loadFarms() {
      var _this3 = this;

      this.setState(function (prev) {
        prev.isLoading = true;
      }, function () {
        fetch(_this3.props.loadFarmsUrl, {
          credentials: 'include'
        }).then(_fetchUtils.default.checkStatus).then(function (result) {
          if (!_this3._isMounted) {
            return;
          }

          _this3.setState(function (prev) {
            prev.list = result.body;
            prev.isLoading = false;
            return prev;
          });
        }).catch(function (err) {
          void 0;

          if (!_this3._isMounted) {
            return;
          }

          _this3.setState(function (prev) {
            prev.isLoading = false;
            return prev;
          });
        });
      });
    }
    /**
     *
     * @param val
     * @param row
     * @returns {*}
     */

  }, {
    key: "columnFarmDetailLink",
    value: function columnFarmDetailLink(val, row) {
      var t = this.props.t;
      if (!row.id) return /*#__PURE__*/_react.default.createElement("span", null, "-");
      return /*#__PURE__*/_react.default.createElement("a", {
        className: "icon-link",
        href: "/farm/".concat(row.id),
        title: t('Edit')
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "icon icon-detail"
      }));
    }
    /**
     *
     * @param val
     * @param row
     * @returns {string}
     */

  }, {
    key: "columnDateCreate",
    value: function columnDateCreate(val, row) {
      return (0, _formatDate.formatDate)(row.date_create);
    }
    /**
     *
     * @param val
     * @param row
     * @returns {string}
     */

  }, {
    key: "columnCanton",
    value: function columnCanton(val, row) {
      // eslint-disable-next-line camelcase
      return row.canton_name ? row.canton_name : '-';
    }
  }]);

  return DashboardFarmList;
}(_react.default.Component);

DashboardFarmList.propTypes = {
  history: _propTypes.default.shape({
    push: _propTypes.default.func.isRequired
  }),
  t: _propTypes.default.func.isRequired,
  loadFarmsUrl: _propTypes.default.string.isRequired,
  i18n: _propTypes.default.shape({
    language: _propTypes.default.string
  })
};
var _default = DashboardFarmList;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/dashboard-farm-list/index.js
// module id = 266
// module chunks = 0